module.exports = __webpack_public_path__ + "assets/img/rule_2.ee71ba7b.png";